import { useCallback } from "react";
import { useDataProvider, useGetIdentity } from "ra-core";

import type { CompanyFolder } from "../types";
import { mapCompanyImportRow } from "./mapCompanyImportRow";

export function useCompanyImport(folder: CompanyFolder | null) {
  const dataProvider = useDataProvider();
  const { identity } = useGetIdentity();

  return useCallback(
    async (batch: Record<string, unknown>[]): Promise<number> => {
      if (!folder) {
        return 0;
      }

      let created = 0;

      for (const row of batch) {
        const mapped = mapCompanyImportRow(row);
        if (!mapped.name) {
          continue;
        }

        try {
          await dataProvider.create("companies", {
            data: {
              name: mapped.name,
              phone_number: mapped.phone_number || null,
              website: mapped.website || null,
              linkedin_url: mapped.linkedin_url || null,
              email: mapped.email || null,
              instagram: mapped.instagram || null,
              tiktok: mapped.tiktok || null,
              facebook: mapped.facebook || null,
              youtube: mapped.youtube || null,
              maps_url: mapped.maps_url || null,
              address: mapped.address || null,
              city: mapped.city || folder.city || null,
              country: mapped.country || null,
              rating: mapped.rating,
              reviews_count: mapped.reviews_count,
              description: mapped.extraNotes || null,
              origin: folder.origin || "prospector_maps",
              sector: folder.sector || null,
              list_id: folder.id,
              sales_id: identity?.id ?? null,
            },
          });
          created += 1;
        } catch (error) {
          console.error(
            "useCompanyImport: no se pudo crear",
            mapped.name,
            error,
          );
        }
      }

      return created;
    },
    [dataProvider, folder, identity?.id],
  );
}
